import * as ng from 'angular';

export const StPipe = () => (<angular.IDirective>{
    require: 'stTable',
    scope: {
        stPipe: '='
    },
    link: {
        pre: (scope: any, element, attrs, ctrl: any) => {
            if (ng.isFunction(scope.stPipe)) {
                ctrl.preventPipe();
                ctrl.pipe = ng.bind(ctrl, scope.stPipe, ctrl.getTableState());
            }
        }
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-pipe/st-pipe.directive.ts